const initialiseLandingPage = () => {
  const isLandingPage = Array.from(document.body.classList).some((cls) => /cms-/.test(cls));
  if (isLandingPage) {
    import("./LandingPage").then((loadedModule) => {
      loadedModule.initialiseOnDocumentReady();
    });
  }
};

export { initialiseLandingPage };
